/*========GET CYCLE PAGE========*/
export const GET_CYCLE_PAGE_INITIAL           = 'GET_CYCLE_PAGE_INITIAL';
export const GET_CYCLE_PAGE_SUCCESS           = 'GET_CYCLE_PAGE_SUCCESS';
export const GET_CYCLE_PAGE_FAIL              = 'GET_CYCLE_PAGE_FAIL';

/*========CLOSE CYCLE========*/
export const CLOSE_CYCLE_SUCCESS              = 'CLOSE_CYCLE_SUCCESS';
export const CLOSE_CYCLE_FAIL                 = 'CLOSE_CYCLE_FAIL';

/*========GET REPORT========*/
export const GET_REPORT                       = 'GET_REPORT';
export const GET_REPORT_SUCCESS               = 'GET_REPORT_SUCCESS';
export const GET_REPORT_FAIL                  = 'GET_REPORT_FAIL';

/*========GET REPORT BY BANKER========*/
export const GET_REPORT_BY_BANKER             = 'GET_REPORT_BY_BANKER';
export const GET_REPORT_BY_BANKER_SUCCESS     = 'GET_REPORT_BY_BANKER_SUCCESS';
export const GET_REPORT_BY_BANKER_FAIL        = 'GET_REPORT_BY_BANKER_FAIL';

/*========GET REPORT BY MEMBER========*/
export const GET_REPORT_BY_MEMBER             = 'GET_REPORT_BY_MEMBER';
export const GET_REPORT_BY_MEMBER_SUCCESS     = 'GET_REPORT_BY_MEMBER_SUCCESS';
export const GET_REPORT_BY_MEMBER_FAIL        = 'GET_REPORT_BY_MEMBER_FAIL';

/*========MONEY EXCHANGE========*/
export const MONEY_EXCHANGE                   = 'MONEY_EXCHANGE';
export const MONEY_EXCHANGE_SUCCESS           = 'MONEY_EXCHANGE_SUCCESS';
export const MONEY_EXCHANGE_FAIL              = 'MONEY_EXCHANGE_FAIL';

/*========CHANGE MONEY EXCHANGE========*/
export const CHANGE_MONEY_EXCHANGE_IDS        = 'CHANGE_MONEY_EXCHANGE_IDS';

/*========CHANGE STATUS BUTTON MONEY EXCHANGE========*/
export const CHANGE_STATUS_BTN_MONEY_EXCHANGE = 'CHANGE_STATUS_BTN_MONEY_EXCHANGE';